import { render, staticRenderFns } from "./MarketingActivityEdit.vue?vue&type=template&id=b8f81ff6&scoped=true&"
import script from "./MarketingActivityEdit.vue?vue&type=script&lang=js&"
export * from "./MarketingActivityEdit.vue?vue&type=script&lang=js&"
import style0 from "./MarketingActivityEdit.vue?vue&type=style&index=0&id=b8f81ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f81ff6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8f81ff6')) {
      api.createRecord('b8f81ff6', component.options)
    } else {
      api.reload('b8f81ff6', component.options)
    }
    module.hot.accept("./MarketingActivityEdit.vue?vue&type=template&id=b8f81ff6&scoped=true&", function () {
      api.rerender('b8f81ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/MarketingActivityEdit.vue"
export default component.exports